export const QUOTATION_PDF_FONT_FAMILY = 'Helvetica';

export const QUOTATION_PDF_COLORS = {
  ink: '#10243c',
  muted: '#5f6c7b',
  accent: '#0f4c81',
  topPanel: '#f2e2b7',
  projectPanel: '#f2c4a5',
  feePanel: '#c4dfad',
  border: '#c8b496',
  structuralTint: '#d8edd0',
  civilTint: '#f7dad6',
  generalTint: '#e4edf6',
  white: '#ffffff',
  acceptanceGuide: '#8d8d8d',
  line: '#d5dbe2',
  lineSoft: '#e2e8f0',
  notePanel: '#fbf7ea',
} as const;

export const QUOTATION_PDF_FONT_SIZES = {
  micro: 7.6,
  caption: 7.6,
  small: 7.6,
  bodySmall: 9.2,
  body: 9.2,
  bodyLarge: 9.2,
  sectionHeading: 14.5,
  summaryHeading: 14.5,
  pageHeading: 14.5,
  acceptanceHeading: 14.5,
  title: 19,
} as const;

export const QUOTATION_PDF_LINE_HEIGHTS = {
  tight: 1.2,
  body: 1.35,
  paragraph: 1.45,
} as const;

export const QUOTATION_PDF_SPACING = {
  xxs: 2,
  xs: 4,
  sm: 6,
  md: 8,
  lg: 10,
  xl: 12,
  xxl: 18,
  page: 36,
  pageTop: 26,
  pageBottom: 18,
  acceptanceInset: 40,
} as const;
